<mat-tab-group>
  <mat-tab label="Keys">
    <div class="mt-3">
      <apiKeys-component></apiKeys-component>
    </div>
  </mat-tab>
  <mat-tab label="OSCAL">
    <mat-tab-group>
      <mat-tab label="Catalog">
        <div class="users-component m-3 flex gap-3">
          <div style="min-width: 250px">
            <div>
              <mat-form-field>
                <mat-label>API Key</mat-label>
                <input matInput [(ngModel)]="model['catalog'].apiKey" />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Tenant</mat-label>
                <input
                  matInput
                  readonly
                  [(ngModel)]="model['catalog'].tenantName"
                  readonly
                />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Compliance Area</mat-label>
                <mat-select [(ngModel)]="model['catalog'].complianceArea">
                  <mat-option
                    [value]="complianceArea.name"
                    *ngFor="let complianceArea of complianceAreas"
                  >{{ complianceArea.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <form class="example-form">
                <button
                  mat-raised-button
                  (click)="sendCatalog()"
                  style="border-radius: 6px"
                >
                  Send
                </button>
              </form>
            </div>
            <div style="color: red">{{ error['catalog'] }}</div>
            <div style="color: green">{{ success['catalog'] }}</div>
          </div>

          <div class="flex-auto">
            <h3>TypeScript code</h3>
            <pre
              class="white-space-normal"
            ><code>this.http.get('{{indexConfigService.externalApi}}/api/oscal/catalog/xml?apiKey=...&projectName=...&category=...&tenantName=...').subscribe(...);
            </code></pre>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Profile">
        <div class="users-component m-3 flex gap-3">
          <div style="min-width: 250px">
            <div>
              <mat-form-field>
                <mat-label>API Key</mat-label>
                <input matInput [(ngModel)]="model['profile'].apiKey" />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Tenant</mat-label>
                <input
                  matInput
                  readonly
                  [(ngModel)]="model['profile'].tenantName"
                  readonly
                />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Project Name</mat-label>
                <mat-select [(ngModel)]="model['profile'].projectName">
                  <mat-option
                    [value]="project.name"
                    *ngFor="let project of projects"
                    >{{ project.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-checkbox [(ngModel)]="model['profile'].mergeSection"
                >Merge Section</mat-checkbox
              >
            </div>

            <div>
              <mat-checkbox [(ngModel)]="model['profile'].modifySection"
                >Modify Section</mat-checkbox
              >
            </div>

            <div class="mt-2">
              <form class="example-form">
                <button
                  mat-raised-button
                  (click)="sendProfile()"
                  style="border-radius: 6px"
                >
                  Send
                </button>
              </form>
            </div>

            <div style="color: red">{{ error['catalog'] }}</div>
            <div style="color: green">{{ success['catalog'] }}</div>
          </div>

          <div class="flex-auto">
            <h3>TypeScript code</h3>
            <pre
              class="white-space-normal"
            ><code>this.http.get('{{indexConfigService.externalApi}}/api/oscal/catalog/xml?apiKey=...&projectName=...&category=...&mergeSection=true/false&modifySection=true/false&tenantName=...').subscribe(...);  </code></pre>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Profile by Category">
        <div class="users-component m-3 flex gap-3">
          <div style="min-width: 250px">
            <div>
              <mat-form-field>
                <mat-label>API Key</mat-label>
                <input matInput [(ngModel)]="model['profileCategory'].apiKey" />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Tenant</mat-label>
                <input
                  matInput
                  readonly
                  [(ngModel)]="model['profileCategory'].tenantName"
                  readonly
                />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Project Name</mat-label>
                <mat-select [(ngModel)]="model['profileCategory'].projectName">
                  <mat-option
                    [value]="project.name"
                    *ngFor="let project of projects"
                    >{{ project.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Category</mat-label>
                <input
                  matInput
                  [(ngModel)]="model['profileCategory'].category"
                />
              </mat-form-field>
            </div>

            <div>
              <mat-checkbox [(ngModel)]="model['profileCategory'].mergeSection"
                >Merge Section</mat-checkbox
              >
            </div>

            <div>
              <mat-checkbox [(ngModel)]="model['profileCategory'].modifySection"
                >Modify Section</mat-checkbox
              >
            </div>

            <div class="mt-2">
              <form class="example-form">
                <button
                  mat-raised-button
                  (click)="sendProfileCategory()"
                  style="border-radius: 6px"
                >
                  Send
                </button>
              </form>
            </div>

            <div style="color: red">{{ error['profileCategory'] }}</div>
            <div style="color: green">{{ success['profileCategory'] }}</div>
          </div>

          <div class="flex-auto">
            <h3>TypeScript code</h3>
            <pre
              class="white-space-normal"
            ><code>this.http.get('{{indexConfigService.externalApi}}/api/oscal/catalog/xml?apiKey=...&projectName=...&category=...&mergeSection=true/false&modifySection=true/false&tenantName=...').subscribe(...);</code></pre>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Implementation">
        <div class="users-component m-3 flex gap-3">
          <div style="min-width: 250px">
            <div>
              <mat-form-field>
                <mat-label>API Key</mat-label>
                <input matInput [(ngModel)]="model['implementation'].apiKey" />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Tenant</mat-label>
                <input
                  matInput
                  readonly
                  [(ngModel)]="model['implementation'].tenantName"
                  readonly
                />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Project Name</mat-label>
                <mat-select [(ngModel)]="model['implementation_ext'].project">
                  <mat-option
                    [value]="project"
                    *ngFor="let project of projects"
                    >{{ project.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>IT Profile Name</mat-label>
                <mat-select [(ngModel)]="model['implementation'].itProfileName">
                  <mat-option
                    [value]="itProfile.name"
                    *ngFor="
                      let itProfile of model['implementation_ext'].project
                        ?.itProfiles
                    "
                    >{{ itProfile.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>FedRAMP Level</mat-label>
                <mat-select [(ngModel)]="model['implementation'].fedrampLevel">
                  <mat-option value="">Not a FedRAMP Project</mat-option>
                  <mat-option value="high">High</mat-option>
                  <mat-option value="moderate">Moderate</mat-option>
                  <mat-option value="low">Low</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-radio-group [(ngModel)]="model['implementation'].isRlink">
                <mat-radio-button [value]="false">base64</mat-radio-button>
                <mat-radio-button [value]="true">rlink</mat-radio-button>
              </mat-radio-group>
            </div>

            <div *ngIf="model['implementation'].isRlink">
              <mat-checkbox [(ngModel)]="model['implementation'].dummyRlink"
                >Generate dummy rlinks</mat-checkbox
              >
            </div>

            <div class="mt-2">
              <form class="example-form">
                <button
                  mat-raised-button
                  (click)="sendImplementation()"
                  style="border-radius: 6px"
                >
                  Send
                </button>
              </form>
            </div>

            <div style="color: red">{{ error['catalog'] }}</div>
            <div style="color: green">{{ success['catalog'] }}</div>
          </div>

          <div class="flex-auto">
            <h3>TypeScript code</h3>
            <pre
              class="white-space-normal"
            ><code>this.http.get('{{indexConfigService.externalApi}}/api/oscal/implementation/xml?apiKey=...&projectName=...&itProfileName=...&fedramplevel=high/moderate/low&tenantName=...').subscribe(...);  </code></pre>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Validation">
        <div>
          <mat-form-field>
            <mat-label>API Key</mat-label>
            <input matInput [(ngModel)]="model['validation'].apiKey" />
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Tenant</mat-label>
            <input
              matInput
              readonly
              [(ngModel)]="model['validation'].tenantName"
              readonly
            />
          </mat-form-field>
        </div>

        <form>
          <div>
            <input
                   type="file"
                   (change)="validateImplementationFileSelected($event)"
                   accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"/>
          </div>
        </form>

        <div style="display: flex; flex-direction: row; margin-top: 16px">
          <form class="example-form">
            <button
              mat-raised-button
              (click)="validateImplementationSendEvidence()"
              style="border-radius: 6px"
            >
              Send
            </button>
          </form>
        </div>
        <p-table
          *ngIf="validationData"
          [value]="validationData"
          #controls
          styleClass="risk-table-striped"
        >
          <ng-template pTemplate="caption">
            <div class="flex align-items-center">
              <label class="block font-bold">Total: {{validationTotal}}</label>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="font-bold white-space-nowrap">Error</th>
              <th class="font-bold white-space-nowrap">Location</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                {{ item.error }}
              </td>
              <td>
                <div *ngIf="!item.expanded" style="text-decoration: underline; cursor: pointer;" (click)="item.expanded = true">{{item.ranges.length}} errors</div>
                <div *ngIf="item.expanded" (click)="item.expanded = false">
                  <div *ngFor="let range of item.ranges" style="white-space: nowrap;">row {{range.physicalLocation.region.startLine}} column {{range.physicalLocation.region.startColumn}}</div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </mat-tab>
      <mat-tab label="POAM">
        <div class="users-component m-3 flex gap-3">
          <div style="min-width: 250px">
            <div>
              <mat-form-field>
                <mat-label>API Key</mat-label>
                <input matInput [(ngModel)]="model['poam'].apiKey" />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Tenant</mat-label>
                <input
                  matInput
                  readonly
                  [(ngModel)]="model['poam'].tenantName"
                  readonly
                />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Project Name</mat-label>
                <mat-select [(ngModel)]="model['poam'].projectName">
                  <mat-option
                    [value]="project.name"
                    *ngFor="let project of projects"
                    >{{ project.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-radio-group [(ngModel)]="model['poam'].isRlink">
                <mat-radio-button [value]="false">base64</mat-radio-button>
                <mat-radio-button [value]="true">rlink</mat-radio-button>
              </mat-radio-group>
            </div>

            <div *ngIf="model['poam'].isRlink">
              <mat-checkbox [(ngModel)]="model['poam'].dummyRlink"
                >Generate dummy rlinks</mat-checkbox
              >
            </div>

            <div class="mt-2">
              <form class="example-form">
                <button
                  mat-raised-button
                  (click)="sendPoam()"
                  style="border-radius: 6px"
                >
                  Send
                </button>
              </form>
            </div>

            <div style="color: red">{{ error['poam'] }}</div>
            <div style="color: green">{{ success['poam'] }}</div>
          </div>

          <div class="flex-auto">
            <h3>TypeScript code</h3>
            <pre
              class="white-space-normal"
            ><code>this.http.get('{{indexConfigService.externalApi}}/api/oscal/poam/xml?apiKey=...&projectName=...&&tenantName=...').subscribe(...);</code></pre>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="SAP">
        <div class="users-component m-3 flex gap-3">
          <div style="min-width: 250px">
            <div>
              <mat-form-field>
                <mat-label>API Key</mat-label>
                <input matInput [(ngModel)]="model['sap'].apiKey" />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Tenant</mat-label>
                <input
                  matInput
                  readonly
                  [(ngModel)]="model['sap'].tenantName"
                  readonly
                />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>SAP Profile Name</mat-label>
                <mat-select [(ngModel)]="model['sap'].profileName">
                  <mat-option
                    [value]="profile.name"
                    *ngFor="let profile of sapProfiles"
                    >{{ profile.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-radio-group [(ngModel)]="model['sap'].isRlink">
                <mat-radio-button [value]="false">base64</mat-radio-button>
                <mat-radio-button [value]="true">rlink</mat-radio-button>
              </mat-radio-group>
            </div>

            <div *ngIf="model['sap'].isRlink">
              <mat-checkbox [(ngModel)]="model['sap'].dummyRlink"
                >Generate dummy rlinks</mat-checkbox
              >
            </div>

            <div class="mt-2">
              <form class="example-form">
                <button
                  mat-raised-button
                  (click)="sendSap()"
                  style="border-radius: 6px"
                >
                  Send
                </button>
              </form>
            </div>

            <div style="color: red">{{ error['sap'] }}</div>
            <div style="color: green">{{ success['sap'] }}</div>
          </div>

          <div class="flex-auto">
            <h3>TypeScript code</h3>
            <pre
              class="white-space-normal"
            ><code>this.http.get('{{indexConfigService.externalApi}}/api/oscal/sap/xml?apiKey=...&projectName=...&tenantName=...').subscribe(...);</code></pre>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="SAR">
        <div class="users-component m-3 flex gap-3">
          <div style="min-width: 250px">
            <div>
              <mat-form-field>
                <mat-label>API Key</mat-label>
                <input matInput [(ngModel)]="model['sar'].apiKey" />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Tenant</mat-label>
                <input
                  matInput
                  readonly
                  [(ngModel)]="model['sar'].tenantName"
                  readonly
                />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>SAR Profile Name</mat-label>
                <mat-select [(ngModel)]="model['sar'].profileName">
                  <mat-option
                    [value]="profile.name"
                    *ngFor="let profile of sarProfiles"
                    >{{ profile.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>SAP Profile Name</mat-label>
                <mat-select [(ngModel)]="model['sar'].sapProfileName">
                  <mat-option
                    [value]="profile.name"
                    *ngFor="let profile of sapProfiles"
                    >{{ profile.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-radio-group [(ngModel)]="model['sar'].isRlink">
                <mat-radio-button [value]="false">base64</mat-radio-button>
                <mat-radio-button [value]="true">rlink</mat-radio-button>
              </mat-radio-group>
            </div>

            <div *ngIf="model['sar'].isRlink">
              <mat-checkbox [(ngModel)]="model['sar'].dummyRlink"
                >Generate dummy rlinks</mat-checkbox
              >
            </div>

            <div class="mt-2">
              <form class="example-form">
                <button
                  mat-raised-button
                  (click)="sendSar()"
                  style="border-radius: 6px"
                >
                  Send
                </button>
              </form>
            </div>

            <div style="color: red">{{ error['sar'] }}</div>
            <div style="color: green">{{ success['sar'] }}</div>
          </div>
          <div class="flex-auto">
            <h3>TypeScript code</h3>
            <pre><code>this.http.get('{{indexConfigService.externalApi}}/api/oscal/sar/xml?apiKey=...&projectName=...&tenantName=...').subscribe(...);</code></pre>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-tab>
  <mat-tab label="Apps">
    <mat-tab-group>
      <mat-tab label="Evidence">
        <div
          class="users-component"
          style="height: 100%; margin-left: 40px; margin-top: 30px"
        >
          <div>
            <mat-form-field>
              <mat-label>API Key</mat-label>
              <input matInput [(ngModel)]="model['evidence'].apiKey" />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Tenant</mat-label>
              <input
                matInput
                readonly
                [(ngModel)]="model['evidence'].tenantName"
                readonly
              />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Project Name</mat-label>
              <mat-select [(ngModel)]="model['evidence'].projectName">
                <mat-option
                  [value]="project.name"
                  *ngFor="let project of projects"
                  >{{ project.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Compliance Area</mat-label>
              <mat-select [(ngModel)]="model['evidence'].complianceAreaName">
                <mat-option
                  [value]="complianceArea.name"
                  *ngFor="let complianceArea of complianceAreas"
                >{{ complianceArea.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Control Item ID</mat-label>
              <input matInput [(ngModel)]="model['evidence'].controlItemId" />
            </mat-form-field>
          </div>

          <form>
            <div>
              <input
                     type="file"
                     (change)="fileSelected($event)"
                     accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"/>
            </div>
          </form>

          <div style="display: flex; flex-direction: row; margin-top: 16px">
            <form class="example-form">
              <button
                mat-raised-button
                (click)="sendEvidence()"
                style="border-radius: 6px"
              >
                Send
              </button>
            </form>
          </div>

          <div style="color: red">{{ error['evidence'] }}</div>
          <div style="color: green">{{ success['evidence'] }}</div>

          <h3>TypeScript code</h3>
          <pre>
  <code>  let formData = new FormData();
    formData.append("apiKey", apiKey);
    formData.append("tenantName", tenantName);
    formData.append("projectName", projectName);
    formData.append("controlItemId", controlItemId);
    formData.append("complianceAreaName", complianceAreaName);
    formData.append('evidence', file, file.name);
    this.http.post('{{indexConfigService.externalApi}}/api/projectcontrolitem/evidence', formData).subscribe(...);  </code>
</pre>
        </div>
      </mat-tab>
      <mat-tab label="IR">
        <div
          class="users-component"
          style="height: 100%; margin-left: 40px; margin-top: 30px"
        >
          <div>
            <mat-form-field>
              <mat-label>API Key</mat-label>
              <input matInput [(ngModel)]="model['getActionPlan'].apiKey" />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Tenant</mat-label>
              <input
                matInput
                [(ngModel)]="model['getActionPlan'].tenantName"
                readonly
              />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Project Name</mat-label>
              <mat-select
                [(ngModel)]="model['getActionPlan']['actionPlan'].projectName"
              >
                <mat-option
                  [value]="project.name"
                  *ngFor="let project of projects"
                >{{ project.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Compliance Area</mat-label>
              <mat-select [(ngModel)]="model['getActionPlan']['actionPlan'].complianceAreaName">
                <mat-option
                  [value]="complianceArea.name"
                  *ngFor="let complianceArea of complianceAreas"
                >{{ complianceArea.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Control Item ID</mat-label>
              <input
                matInput
                [(ngModel)]="model['getActionPlan']['actionPlan'].controlItemId"
              />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field class="description-form">
              <mat-label>POAM Name</mat-label>
              <input
                matInput
                [(ngModel)]="model['getActionPlan']['actionPlan'].name"
              />
            </mat-form-field>
          </div>

          <div style="display: flex; flex-direction: row; margin-top: 16px">
            <form class="example-form">
              <button
                mat-raised-button
                (click)="getProjectPoam()"
                style="border-radius: 6px"
              >
                Generate
              </button>
            </form>
          </div>

          <div style="margin-top: 20px;">
            <mat-form-field>
              <mat-label>Integration</mat-label>
              <mat-select [(ngModel)]="model['getActionPlan']['actionPlan'].integrationId">
                <mat-option
                  [value]="integration.name"
                  *ngFor="let integration of integrations"
                >{{ integration.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div style="display: flex; flex-direction: row; margin-top: 16px">
            <form class="example-form">
              <button
                mat-raised-button
                (click)="sendProjectPoamToIntegration()"
                style="border-radius: 6px"
              >
                Send
              </button>
            </form>
          </div>

          <div style="color: red">{{ error['getActionPlan'] }}</div>
          <div style="color: green">{{ success['getActionPlan'] | json }}</div>

          <h3>TypeScript code</h3>
          <pre>
  <code>
    fetch('{{indexConfigService.externalApi}}/api/projectcontrolitem/poam?apiKey=...&tenantName={{tenantName}}', {{'{'}}
    method: 'POST',
      headers: {{'{'}}
    'Content-Type': 'application/json'
    {{'}'}},
      body: JSON.stringify({{'{'}}
    "projectName": "...",
        "complianceAreaName": "...",
        "controlItemId": "...",
        "name": "...",
        "weaknessDescription": "...",
        "howIdentified": "...",
        "responsibleParty": "...",
        "identificationDate": "2023-07-05T22:00:00.000Z",
        "scheduledCompletionDate": "2023-07-13T22:00:00.000Z",
        "actualCompletionDate": "2023-07-18T22:00:00.000Z",
        "currentStatus": 0/1/2,
        "riskLevel": "Low/Medium/High",
        "remediationPlansActionsMilestones": "...",
        "changesToRemediationPlansActionsMilestones": "...",
        "comments": ".,..",
        "attachments": [
    {{'{'}}
    "name": "...",
            "content": "BASE64 encoded file"
    {{'}'}},
          ...
        ]
    {{'}'}})
    {{'}'}});  </code>
</pre>
        </div>
      </mat-tab>
      <mat-tab label="Add/Update POAM">
        <div
          class="users-component"
          style="height: 100%; margin-left: 40px; margin-top: 30px"
        >
          <div>
            <mat-form-field>
              <mat-label>API Key</mat-label>
              <input matInput [(ngModel)]="model['actionPlan'].apiKey" />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Tenant</mat-label>
              <input
                matInput
                [(ngModel)]="model['actionPlan'].tenantName"
                readonly
              />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Project Name</mat-label>
              <mat-select
                [(ngModel)]="model['actionPlan']['actionPlan'].projectName"
              >
                <mat-option
                  [value]="project.name"
                  *ngFor="let project of projects"
                  >{{ project.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Compliance Area</mat-label>
              <mat-select [(ngModel)]="model['actionPlan']['actionPlan'].complianceAreaName">
                <mat-option
                  [value]="complianceArea.name"
                  *ngFor="let complianceArea of complianceAreas"
                >{{ complianceArea.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Control Item ID</mat-label>
              <input
                matInput
                [(ngModel)]="model['actionPlan']['actionPlan'].controlItemId"
              />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field class="description-form">
              <mat-label>Name</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                type="text"
                class="form-control"
                name="name"
                [(ngModel)]="model['actionPlan']['actionPlan'].name"
                rows="10"
                cols="80"
                required
              >
              </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="description-form">
              <mat-label>Description</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                type="text"
                class="form-control"
                [(ngModel)]="
                  model['actionPlan']['actionPlan'].weaknessDescription
                "
                rows="10"
                cols="80"
                required
              >
              </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="description-form">
              <mat-label>How Identified</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                type="text"
                class="form-control"
                name="howIdentified"
                [(ngModel)]="model['actionPlan']['actionPlan'].howIdentified"
                required
              >
              </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Responsible Party</mat-label>
              <input
                matInput
                name="responsibleParty"
                [(ngModel)]="model['actionPlan']['actionPlan'].responsibleParty"
                required
              />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Date of Identification</mat-label>
              <input
                matInput
                [matDatepicker]="identificationDatePicker"
                name="identificationDate"
                [(ngModel)]="
                  model['actionPlan']['actionPlan'].identificationDate
                "
                required
              />

              <mat-datepicker-toggle
                matSuffix
                [for]="identificationDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #identificationDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Scheduled Completion Date</mat-label>
              <input
                matInput
                [matDatepicker]="scheduledCompletionDatePicker"
                name="scheduledCompletionDate"
                [(ngModel)]="
                  model['actionPlan']['actionPlan'].scheduledCompletionDate
                "
                required
              />

              <mat-datepicker-toggle
                matSuffix
                [for]="scheduledCompletionDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #scheduledCompletionDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Actual Completion Date</mat-label>
              <input
                matInput
                [matDatepicker]="actualCompletionDatePicker"
                name="actualCompletionDate"
                [(ngModel)]="
                  model['actionPlan']['actionPlan'].actualCompletionDate
                "
              />

              <mat-datepicker-toggle
                matSuffix
                [for]="actualCompletionDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #actualCompletionDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Current Status</mat-label>
              <mat-select
                [(ngModel)]="model['actionPlan']['actionPlan'].currentStatus"
                required
              >
                <mat-option [value]="0">0 - Not Started</mat-option>
                <mat-option [value]="1">1 - In-Progress</mat-option>
                <mat-option [value]="2">2 - Resolved</mat-option>
                <mat-option [value]="3">3 - Awaiting Review</mat-option>
                <mat-option [value]="4">4 - Reviewed - Not POAM</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Risk Level</mat-label>
              <mat-select
                [(ngModel)]="model['actionPlan']['actionPlan'].riskLevel"
              >
                <mat-option [value]="'High'">High</mat-option>
                <mat-option [value]="'Medium'">Medium</mat-option>
                <mat-option [value]="'Low'">Low</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field class="description-form">
              <mat-label>Remediation Plans, Actions and Milestones</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                type="text"
                class="form-control"
                name="remediationPlansActionsMilestones"
                [(ngModel)]="
                  model['actionPlan']['actionPlan']
                    .remediationPlansActionsMilestones
                "
                required
              >
              </textarea>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field class="description-form">
              <mat-label
                >Changes to Remediation Plans, Actions, and Milestones (if
                applicable)</mat-label
              >
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                type="text"
                class="form-control"
                name="changesToRemediationPlansActionsMilestones"
                [(ngModel)]="
                  model['actionPlan']['actionPlan']
                    .changesToRemediationPlansActionsMilestones
                "
                rows="10"
                cols="80"
              >
              </textarea>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field class="description-form">
              <mat-label>Comments</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                type="text"
                class="form-control"
                name="comments"
                rows="10"
                [(ngModel)]="model['actionPlan']['actionPlan'].comments"
                cols="80"
              >
              </textarea>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Attachment Name</mat-label>
              <input
                matInput
                [(ngModel)]="
                  model['actionPlan']['actionPlan']['attachments'][0].name
                "
                required
              />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="description-form">
              <mat-label>Attachment BASE64 encoded content</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                type="text"
                class="form-control"
                name="comments"
                rows="10"
                [(ngModel)]="
                  model['actionPlan']['actionPlan']['attachments'][0].content
                "
                cols="80"
              >
              </textarea>
            </mat-form-field>
          </div>

          <div style="display: flex; flex-direction: row; margin-top: 16px">
            <form class="example-form">
              <button
                mat-raised-button
                (click)="sendProjectPoam()"
                style="border-radius: 6px"
              >
                Send
              </button>
            </form>
          </div>

          <div style="color: red">{{ error['actionPlan'] }}</div>
          <div style="color: green">{{ success['actionPlan'] }}</div>

          <h3>TypeScript code</h3>
          <pre>
  <code>
    fetch('{{indexConfigService.externalApi}}/api/projectcontrolitem/poam?apiKey=...&tenantName={{tenantName}}', {{'{'}}
      method: 'POST',
      headers: {{'{'}}
        'Content-Type': 'application/json'
      {{'}'}},
      body: JSON.stringify({{'{'}}
        "projectName": "...",
        "complianceAreaName": "...",
        "controlItemId": "...",
        "name": "...",
        "weaknessDescription": "...",
        "howIdentified": "...",
        "responsibleParty": "...",
        "identificationDate": "2023-07-05T22:00:00.000Z",
        "scheduledCompletionDate": "2023-07-13T22:00:00.000Z",
        "actualCompletionDate": "2023-07-18T22:00:00.000Z",
        "currentStatus": 0/1/2,
        "riskLevel": "Low/Medium/High",
        "remediationPlansActionsMilestones": "...",
        "changesToRemediationPlansActionsMilestones": "...",
        "comments": ".,..",
        "attachments": [
          {{'{'}}
            "name": "...",
            "content": "BASE64 encoded file"
          {{'}'}},
          ...
        ]
      {{'}'}})
    {{'}'}});  </code>
</pre>
        </div>
      </mat-tab>
      <mat-tab label="Integrations">
        <integration-apps
          [projects]="projects"
          [sapProfiles]="sapProfiles"
          [sarProfiles]="sarProfiles"
        ></integration-apps>
      </mat-tab>
      <mat-tab label="The Vault">

        <div>
          <mat-form-field>
            <mat-label>API Key</mat-label>
            <input matInput [(ngModel)]="model['dictionary'].apiKey" />
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Tenant</mat-label>
            <input
              matInput
              readonly
              [(ngModel)]="model['dictionary'].tenantName"
              readonly
            />
          </mat-form-field>
        </div>

        <form>
          <div>
            <input
                   type="file"
                   (change)="dictionaryFileSelected($event)"
                   accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"/>
          </div>
        </form>

        <div style="display: flex; flex-direction: row; margin-top: 16px">
          <form class="example-form">
            <button
              mat-raised-button
              (click)="sendDictionary()"
              style="border-radius: 6px"
            >
              Send
            </button>
          </form>
        </div>

        <div style="color: red">{{ error['dictionary'] }}</div>
        <div style="color: green">{{ success['dictionary'] }}</div>

        <h3>TypeScript code</h3>
        <pre>
          <code>
              let formData = new FormData();
              formData.append("apiKey", apiKey);
              formData.append("tenantName", tenantName);
              formData.append('data', file, file.name);
              this.http.post('{{indexConfigService.externalApi}}/api/dictionary/', formData).subscribe(...);
          </code>
        </pre>
<h4>Example data</h4>
        <mat-tab-group>
          <mat-tab label="XML">
        <pre>
&lt;?xml version="1.0" encoding="utf-16"?&gt;
  &lt;vendors&gt;<br>   &lt;vendor name="Amazon" url="https://aws.amazon.com"&gt;<br>    &lt;guidance&gt;<br>      &lt;![CDATA[<br>          &lt;div&gt;<br>            Any formatted text<br>          &lt;/div&gt;<br>      ]]&gt;<br>    &lt;/guidance&gt;<br>    &lt;service name="AWS"&gt;<br>      &lt;customer-responsibilities&gt;<br>        &lt;![CDATA[<br>          &lt;div&gt;<br>            Any formatted text<br>          &lt;/div&gt;<br>       ]]&gt;<br>      &lt;/customer-responsibilities&gt;<br>      &lt;implementation-details&gt;<br>        &lt;![CDATA[<br>          &lt;div&gt;<br>            Any formatted text<br>          &lt;/div&gt;<br>       ]]&gt;<br>      &lt;/implementation-details&gt;<br>    &lt;/service&gt;<br>    &lt;service name="Firewall"&gt;<br>      &lt;customer-responsibilities&gt;<br>        &lt;![CDATA[<br>          &lt;div&gt;<br>            Any formatted text<br>          &lt;/div&gt;<br>       ]]&gt;<br>      &lt;/customer-responsibilities&gt;<br>      &lt;implementation-details&gt;<br>        &lt;![CDATA[<br>          &lt;div&gt;<br>            Any formatted text<br>          &lt;/div&gt;<br>       ]]&gt;<br>      &lt;/implementation-details&gt;<br>    &lt;/service&gt;<br>  &lt;/vendor&gt;<br>&lt;/vendors&gt;<br>
        </pre>
          </mat-tab>
          <mat-tab label="JSON">
            <pre>
              <code>
{{dictionariesJsonCode}}
              </code>
            </pre>
          </mat-tab>
        </mat-tab-group>
      </mat-tab>
    </mat-tab-group>
  </mat-tab>
</mat-tab-group>
